import React from 'react';
import Selection from './Selection';

const options = [
  { label: 'True', value: 'true', disabled: false },
  { label: 'False', value: 'false', disabled: false },
  { label: 'Unknown', value: 'unknown', disabled: false },
];

type BooleanSelectionProps = {
  defaultValue?: any[];
  setValue: (arg: any) => void;
  allowUnknown?: boolean;
  allowFalse?: boolean;
};

const BooleanSelection: React.FC<BooleanSelectionProps> = ({
  setValue,
  defaultValue,
  allowUnknown = true,
  allowFalse = true,
}) => {
  return (
    <Selection
      options={options.filter(
        (o) =>
          (allowUnknown || o.value !== 'unknown') &&
          (allowFalse || o.value !== 'false')
      )}
      withInput={false}
      setValue={setValue}
      defaultValue={defaultValue}
    />
  );
};

export default BooleanSelection;
